<template>
  <div>
    <div class="container-fluid">
      <div class="row gameplay_pg">
        <div class="iframe_section">
          <iframe src="static/penalty_kicks/index.html" frameborder="0"></iframe>
        </div>
      </div>
    </div>
    <fade-transition>
      <component :is="currentModal" @close="closeModal()" @playNewGame="playNewGame"></component>
    </fade-transition>
  </div>
</template>

<script>
/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
/* postgame.html */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import ResultOfAddOnGame from './ResultOfAddOnGame';

export default {
  name: 'add-on-game',
  mixins: [NewGameMixin],
  components: { FadeTransition },
  data() {
    return {
      currentModal: null,
      gameId: null,
    };
  },
  created() {
    console.log('in AddOnGame created hook');
    if (!this.$route.params.gameId) this.$router.push('/home');
    this.gameId = this.$route.params.gameId;
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage);
  },
  beforeDestroy() {
    this.resetAddOnGameData();
  },
  beforeRouteLeave(to, from, next) {
    console.log('==> inside component\'s beforeRouteLeave:');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    if (['/home', '/searchingOpponent'].includes(to.path)) next();
    else next({ path: '/home' });
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'resetAddOnGameData',
      'setAddOnGameDataSuccess',
    ]),
    goToHomePage() {
      this.$router.push('/home');
      window.location.reload();
    },
    playNewGame() {
      console.log('New Game button clicked in Post Game modal');
      this.currentModal = null;
      this.playGameForPages();
    },
    receiveMessage(event) {
      window.removeEventListener('message', this.receiveMessage);
      // route to net page // modal with these data from index.html (can include if user scored or no)
      console.log(event.data);
      const payload = { success: event.data.ballIn };
      this.setAddOnGameDataSuccess(payload);
      this.currentModal = ResultOfAddOnGame;
      this.showHideModal();
    },
    closeModal() {
      this.getUserLoginDetails().then(() => {
        /* eslint-disable */
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        /* eslint-enable */
        this.$router.push('/home');
      });
    },
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          console.log('user has not leveled up, going to home page');
          /* eslint-disable */
          this.currentModal = null;
          if (this.getUserAvailableGames === 0) {
            sessionStorage.removeItem('zeroBalancePopUp');
          }
          this.getUserLoginDetails().then(() => {
            this.$router.push('/home');
          });
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addongame/AddOnGame.vue